import React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

const Cta = () => {
  return (
    <div className="bg-white dark:bg-zinc-950">
      <div className="mx-auto max-w-7xl py-24 sm:px-6 sm:py-32 lg:px-8">
        <div className="relative isolate overflow-hidden bg-gray-900 px-6 pt-16 shadow-2xl sm:rounded-3xl sm:px-16 md:pt-24 lg:flex lg:gap-x-20 lg:px-24 lg:pt-0">
          <svg
            viewBox="0 0 1024 1024"
            className="absolute left-1/2 top-1/2 -z-10 size-256 -translate-y-1/2 mask-[radial-gradient(closest-side,white,transparent)] sm:left-full sm:-ml-80 lg:left-1/2 lg:ml-0 lg:-translate-x-1/2 lg:translate-y-0"
            aria-hidden="true"
          >
            <circle
              cx="512"
              cy="512"
              r="512"
              fill="url(#statuspage-alt-cta-gradient)"
              fillOpacity="0.7"
            />
            <defs>
              <radialGradient id="statuspage-alt-cta-gradient">
                <stop stopColor="#0c4a6e" />
                <stop offset="1" stopColor="#1e3a8a" />
              </radialGradient>
            </defs>
          </svg>
          <div className="mx-auto max-w-md text-center lg:mx-0 lg:flex-auto lg:py-32 lg:text-left">
            <h2 className="text-balance text-3xl font-semibold tracking-tight text-white sm:text-4xl">
              Ready to switch from Statuspage?
            </h2>
            <p className="mt-6 text-pretty text-lg/8 text-gray-300">
              Sorry&#8482; makes it easy to migrate from Atlassian Statuspage
              and manage all your status pages in one place.
            </p>
            <div className="mt-10 flex items-center justify-center gap-x-6 lg:justify-start">
              <a
                href="https://app.sorryapp.com/people/sign_up?plan=price_0QSH3a596061iK2wzf4dPxQ4&subscribers=1000&pages=1&privacy=false"
                className="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
              >
                Start a Trial
              </a>
              <Link to="/demo" className="text-sm/6 font-semibold text-white">
                Request a demo <span aria-hidden="true">→</span>
              </Link>
            </div>
          </div>
          <div className="relative mt-16 h-80 lg:mt-8">
            <div className="absolute left-0 top-0 w-228 max-w-none">
              <StaticImage
                src="../../../images/status-pages/acme_dark.webp"
                alt="Sorry™ status page for Acme in dark mode showing all systems operational with components Customer Portal at 99.99% uptime, Authentication at 99.99% uptime, API at 100% uptime, Messaging at 100% uptime, and Website at 100% uptime"
                className="rounded-md bg-white/5 ring-1 ring-white/10"
                width={1824}
                height={1080}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cta;
